module.exports = __webpack_public_path__ + "img/5.d30683c7.png";